import type { SectionBentoTabsOrder } from "./types.base";

export const defaultSectionBentoTabsOrderData: SectionBentoTabsOrder = {
  title: "Get more with Xfinity",
  subTitle: "",
  order: ["internet", "mobile", "entertainment", "prepaid"],
  defaultTab: "internet",
};
